import type { Job, Jobs, JobsStatistics } from '../../reducers/jobs/jobs'

export const FETCH_STATISTICS_OF_RECENTLY_POSTED_JOBS: 'dashboard/FETCH_STATISTICS_OF_RECENTLY_POSTED_JOBS' = 'dashboard/FETCH_STATISTICS_OF_RECENTLY_POSTED_JOBS'
export const SET_USER_HAS_REJECTED_JOBS_ACTION: 'dashboard/SET_USER_HAS_REJECTED_JOBS_ACTION' = 'dashboard/SET_USER_HAS_REJECTED_JOBS_ACTION'
export const STORE_FETCHED_STATISTICS_OF_RECENTLY_POSTED_JOBS: 'dashboard/STORE_FETCHED_STATISTICS_OF_RECENTLY_POSTED_JOBS' = 'dashboard/STORE_FETCHED_STATISTICS_OF_RECENTLY_POSTED_JOBS'
export const PUBLISH_JOB_FROM_ERROR_WIDGET: 'dashboard/PUBLISH_JOB_FROM_ERROR_WIDGET' = 'dashboard/PUBLISH_JOB_FROM_ERROR_WIDGET'
export const STORE_RECENTLY_POSTED_JOBS: 'dashboard/STORE_FETCHED_RECENTLY_POSTED_JOBS' = 'dashboard/STORE_FETCHED_RECENTLY_POSTED_JOBS'
export const STORE_RECENTLY_CREATED_DRAFTS: 'dashboard/STORE_FETCHED_RECENTLY_CREATED_DRAFTS' = 'dashboard/STORE_FETCHED_RECENTLY_CREATED_DRAFTS'
export const STORE_JOBS_WITH_ERRORS: 'dashboard/STORE_FETCHED_JOBS_WITH_ERRORS' = 'dashboard/STORE_FETCHED_JOBS_WITH_ERRORS'

export type FetchJobsStatisticsOfRecentlyPostedJobsAction = {
  payload: Array<string>,
  type: typeof FETCH_STATISTICS_OF_RECENTLY_POSTED_JOBS,
}

export type SetLastRejectedJobAction = {
  payload: Job | undefined,
  type: typeof SET_USER_HAS_REJECTED_JOBS_ACTION,
}

export type StoreFetchedStatisticsOfRecentlyPostedJobsAction = {
  payload: JobsStatistics,
  type: typeof STORE_FETCHED_STATISTICS_OF_RECENTLY_POSTED_JOBS,
}

export type PublishJobFromErrorWidgetAction = {
  payload: string,
  type: typeof PUBLISH_JOB_FROM_ERROR_WIDGET,
}

export type StoreRecentlyPostedJobsAction = {
  payload: Jobs,
  type: typeof STORE_RECENTLY_POSTED_JOBS,
}

export type StoreRecentlyCreatedDraftsAction = {
  payload: Jobs,
  type: typeof STORE_RECENTLY_CREATED_DRAFTS,
}

export type StoreJobsWithErrorsAction = {
  payload: Jobs,
  type: typeof STORE_JOBS_WITH_ERRORS,
}

export type DashboardActions =
  FetchJobsStatisticsOfRecentlyPostedJobsAction |
  StoreFetchedStatisticsOfRecentlyPostedJobsAction |
  PublishJobFromErrorWidgetAction |
  StoreRecentlyPostedJobsAction |
  StoreRecentlyCreatedDraftsAction |
  StoreJobsWithErrorsAction |
  SetLastRejectedJobAction

export const fetchStatisticsOfRecentlyPostedJobs = (
  jobIds: Array<string>,
): FetchJobsStatisticsOfRecentlyPostedJobsAction => ({
  payload: jobIds,
  type: FETCH_STATISTICS_OF_RECENTLY_POSTED_JOBS,
})

export const setLastRejectedJob = (
  lastRejectedJob: Job | undefined
): SetLastRejectedJobAction => ({
  payload: lastRejectedJob,
  type: SET_USER_HAS_REJECTED_JOBS_ACTION,
})

export const storeFetchedStatisticsOfRecentlyPostedJobs = (
  jobsStatistics: JobsStatistics
): StoreFetchedStatisticsOfRecentlyPostedJobsAction => ({
  payload: jobsStatistics,
  type: STORE_FETCHED_STATISTICS_OF_RECENTLY_POSTED_JOBS,
})

export const publishJobFromErrorWidget = (jobId: string): PublishJobFromErrorWidgetAction => ({
  payload: jobId,
  type: PUBLISH_JOB_FROM_ERROR_WIDGET,
})

export const storeRecentlyPostedJobs = (jobs: StoreRecentlyPostedJobsAction['payload']): StoreRecentlyPostedJobsAction => ({
  payload: jobs,
  type: STORE_RECENTLY_POSTED_JOBS,
})
export const storeRecentlyCreatedDrafts = (jobs: StoreRecentlyCreatedDraftsAction['payload']): StoreRecentlyCreatedDraftsAction => ({
  payload: jobs,
  type: STORE_RECENTLY_CREATED_DRAFTS,
})

export const storeJobsWithErrors = (jobs: StoreJobsWithErrorsAction['payload']): StoreJobsWithErrorsAction => ({
  payload: jobs,
  type: STORE_JOBS_WITH_ERRORS,
})
